import React, { useState } from 'react';
import s from './LinkedInPostPreview.module.css';
import {useSelector} from "react-redux";
import {selectCurrentProject, selectIsPreviewVisible} from "../../../../store/selectors/projectSelectors";
import FacebookPostPreview from "./FacebookPostPreview";
import LinkedInPostPreview from "./LinkedInPostPreview";
import InstagramPostPreview from "./InstagramPostPreview";
import TwitterPostPreview from "./TwitterPostPreview";
import PreviewButton from "../../../../shared/ui/preview-button/PreviewButton";

interface LinkedInPostPreviewGeneratorProps {
    postText: string;
    image: string|null;
}

const PreviewGenerator: React.FC<LinkedInPostPreviewGeneratorProps> = ({ postText, image }) => {

    const isPreviewVisible=useSelector(selectIsPreviewVisible)
    const currentProject = useSelector(selectCurrentProject);
    const socialNetwork=currentProject?.content_type


    const text = postText
        .replace(/^<p>/, '')
        .replace(/<\/p>$/, '')
        .replace(/<(?!\/?p\b)[^>]+>/g, '');

    const highlightHashtags = (text: string): JSX.Element[] => {
        const hashtagRegex = /#[a-zA-Z0-9_]+/g;
        const paragraphAndBreakRegex = /<\/p>\s*<p>|<br\s*\/?>/g;


        const parts = text.split(paragraphAndBreakRegex);

        const result: JSX.Element[] = [];

        parts.forEach((part, index) => {
            if (index > 0) {
                result.push(<br key={`br-${index}`} />);
            }

            if (part.trim() === "") {
                return;
            }

            const hashtags = part.match(hashtagRegex) || [];
            const textParts = part.split(hashtagRegex);

            textParts.forEach((textPart, subIndex) => {
                result.push(<span key={`text-${index}-${subIndex}`}>{textPart}</span>);

                if (hashtags[subIndex]) {
                    result.push(
                        <span
                            key={`hashtag-${index}-${subIndex}`}
                            className={
                                socialNetwork === 'twitter' || socialNetwork === 'instagram'
                                    ? s.twitterHashtag
                                    : s.hashtag
                            }
                        >
                            {hashtags[subIndex]}
                        </span>
                    );
                }
            });
        });

        return result;
    };


    return (
        <div className={s.container}>
            {isPreviewVisible ? (
                <div>
                    {socialNetwork === 'linkedin' && <LinkedInPostPreview
                        image={image}
                        text={text}
                        highlightHashtags={highlightHashtags}
                    />}
                    {socialNetwork === 'facebook' && <FacebookPostPreview
                        image={image}
                        text={text}
                        highlightHashtags={highlightHashtags}/>}
                    {socialNetwork === 'instagram' && <InstagramPostPreview
                        image={image}
                        text={text}
                        highlightHashtags={highlightHashtags}/>}
                    {socialNetwork === 'twitter' && <TwitterPostPreview
                        image={image}
                        text={text}
                        highlightHashtags={highlightHashtags}/>}
                </div>
            ) : <PreviewButton isBackground={true}/>}
        </div>
    );
};

export default PreviewGenerator;
